export enum VerificationStatus {
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  WARNING = 'WARNING',
  IN_REVIEW = 'IN_REVIEW',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  REDO = 'REDO',
}
